var Elemento = /** @class */ (function () {
    function Elemento(elemento) {
        var _this = this;
        this.elemento = elemento;
        this.devuelveElemento = function () {
            if (_this.siguiente) {
                _this.padre.insertBefore(_this.elemento, _this.siguiente);
            }
            else {
                _this.padre.appendChild(_this.elemento);
            }
            _this.cambiado = false;
        };
        this.cambiado = false;
        this.padre = elemento.parentNode;
        this.siguiente = elemento.nextElementSibling;
        var atributo = elemento.getAttribute('data-mover') || elemento.getAttribute('data-mover-inverso');
        if (atributo === null) {
            throw Error("Falta el atributo data-mover o data-mover-inverso");
        }
        this.atributo = atributo;
    }
    Elemento.prototype.cambiaElemento = function () {
        var trozos = this.atributo.split('|'), referencia = document.querySelector(trozos[1]), posicion = trozos[0];
        if (referencia) {
            switch (posicion) {
                case 'append':
                    referencia.appendChild(this.elemento);
                    break;
            }
            this.cambiado = true;
        }
    };
    return Elemento;
}());
var Mover = /** @class */ (function () {
    function Mover(breakpoint) {
        if (breakpoint === void 0) { breakpoint = '(min-width: 64em)'; }
        var _this = this;
        this.monitoriza = function () { return _this.mq.addListener(_this.compruebaCambios); };
        this.pausa = function () { return _this.mq.removeListener(_this.compruebaCambios); };
        this.creaElementos = function (selector) {
            return [].slice.call(document.querySelectorAll(selector)).map(_this.creaElemento);
        };
        this.creaElemento = function (elemento) { return new Elemento(elemento); };
        this.compruebaCambios = function () {
            if (_this.mq.matches) {
                _this.devuelveElementos(_this.elementos);
                _this.cambiaElementos(_this.elementosInversos);
            }
            else {
                _this.cambiaElementos(_this.elementos);
                _this.devuelveElementos(_this.elementosInversos);
            }
        };
        this.cambiaElementos = function (elementos) {
            elementos.filter(function (x) { return !x.cambiado; }).forEach(function (elemento) { return elemento.cambiaElemento(); });
        };
        this.devuelveElementos = function (elementos) { return elementos.filter(function (x) { return x.cambiado; })
            .forEach(function (elemento) { return elemento.devuelveElemento(); }); };
        this.elementos = this.creaElementos('[data-mover]');
        this.elementosInversos = this.creaElementos('[data-mover-inverso]');
        this.mq = matchMedia(breakpoint);
        this.compruebaCambios();
        this.mq.addListener(this.compruebaCambios);
    }
    return Mover;
}());
export default Mover;
